export interface AiThinkingProps {
  label: string;
  size?: 'default' | 'small';
}

/** Shared "waiting on AI" row: spinner + a short, contextual line of copy. */
export function AiThinking({ label, size = 'default' }: AiThinkingProps): React.JSX.Element {
  const className = size === 'small' ? 'ai-thinking ai-thinking--sm' : 'ai-thinking';
  return (
    <div className={className} role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span className="msg">{label}</span>
    </div>
  );
}
